import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arrow-Up",
  "use": "icon-Arrow-Up-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-Arrow-Up\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.353 1.783a.5.5 0 0 0-.707 0L2.818 4.61a.5.5 0 0 0 .707.707L5.5 3.343V10a.5.5 0 0 0 1 0V3.343l1.975 1.975a.5.5 0 1 0 .707-.707L6.353 1.783Z\" fill=\"#069A49\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol